import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Forms", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_SignupForm = _resolveComponent("SignupForm")!
  const _component_ResetPasswordForm = _resolveComponent("ResetPasswordForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.mode === 'login')
      ? (_openBlock(), _createBlock(_component_LoginForm, {
          key: 0,
          onLogin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoPage('Profile')))
        }))
      : _createCommentVNode("", true),
    (_ctx.mode === 'signup')
      ? (_openBlock(), _createBlock(_component_SignupForm, {
          key: 1,
          onSignup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoPage('Profile')))
        }))
      : _createCommentVNode("", true),
    (_ctx.mode === 'reset')
      ? (_openBlock(), _createBlock(_component_ResetPasswordForm, {
          key: 2,
          onReset: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoPage('Welcome')))
        }))
      : _createCommentVNode("", true)
  ]))
}